// src/utils/sound.js — Notificaciones de sonido con Web Audio API (sin archivos externos)

function play(notes) {
    try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        let time = ctx.currentTime;
        notes.forEach(({ freq, duration, volume = 0.3 }) => {
            const osc  = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.type = 'sine';
            osc.frequency.value = freq;
            gain.gain.setValueAtTime(volume, time);
            gain.gain.exponentialRampToValueAtTime(0.001, time + duration);
            osc.start(time);
            osc.stop(time + duration);
            time += duration * 0.75;
        });
    } catch (e) {
        // Audio bloqueado por política del navegador o no soportado
    }
}

/** Doble tono ascendente — nuevo ticket */
export function playTicketSound() {
    play([
        { freq: 880,  duration: 0.15 },
        { freq: 1100, duration: 0.25 }
    ]);
}

/** Ping suave — nuevo comentario */
export function playCommentSound() {
    play([{ freq: 660, duration: 0.2 }]);
}

/** Triple tono urgente — nueva solicitud de autorización */
export function playAuthRequestSound() {
    play([
        { freq: 880,  duration: 0.12, volume: 0.4 },
        { freq: 1100, duration: 0.12, volume: 0.4 },
        { freq: 1320, duration: 0.22, volume: 0.45 },
    ]);
}

/** Tono suave de confirmación — autorización completada */
export function playAuthCompletedSound() {
    play([
        { freq: 523, duration: 0.15, volume: 0.3 },
        { freq: 659, duration: 0.25, volume: 0.3 },
    ]);
}
